import type { ISettingsProfileForm } from 'features/SettingsOld/interfaces/ISettings'

export type EmrPinConfig = {
  /** Every PIN that unlocks the intake gate (staff PINs + doctor PIN). */
  pins: string[]
  pinLength: number
}

const EMPTY_CONFIG: EmrPinConfig = { pins: [], pinLength: 0 }

export const getEmrPinConfig = (profile?: ISettingsProfileForm | null): EmrPinConfig => {
  if (!profile) return EMPTY_CONFIG

  const usersPin = profile.emr_users_pin
  const listPins = (usersPin?.emr_pin ?? []).map(String).filter(Boolean)

  if (listPins.length > 0) {
    const pinLength = usersPin?.pin_settings?.pin_length || listPins[0].length
    return { pins: listPins, pinLength }
  }

  const fallbackPin = String(profile.emr_pin ?? '')
  if (!fallbackPin) return EMPTY_CONFIG

  return { pins: [fallbackPin], pinLength: fallbackPin.length }
}
